<template>
  <v-app>
    <v-app-bar app color="primary" dark height="125px">
      <div class="d-flex align-center">
        <h2 class="ml-6 text-xl font-bold">Datums kiezen</h2>
      </div>

      <v-spacer></v-spacer>
      <v-img
        v-if="isTweb"
        :src="require('@/assets/images/logo/logo.svg')"
        class="my-3 m-4 p-6 logo h-full"
        max-width="200px"
        contain
      />
      <v-img
        v-else
        :src="theme.imageUrl"
        class="my-3 m-4 p-6 logo h-full"
        max-width="200px"
        contain
      />
    </v-app-bar>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Fulllayout",
  computed: {
    ...mapGetters({
      theme: "theme/getTheme",
    }),
    isTweb() {
      return this.theme.primaryColor == "#315DA7";
    },
  },
};
</script>
